import * as React from "react";

import type { IconProps } from "./types";

export const ArrowLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M14.5 8L1.5 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M4.75 11L1.5 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M4.75 5L1.5 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  ),
);

export default ArrowLeftIcon;
